module.exports = __webpack_public_path__ + "static/media/rundoo-inc.01782cd8.png";